import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  openApprovalsCount: number;
}

export function MarkReadyConfirmModal({
  open,
  onClose,
  onConfirm,
  openApprovalsCount,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Mark Ready for Production?</DialogTitle>
        </DialogHeader>
        {openApprovalsCount > 0 ? (
          <p className="text-amber-700">
            This Job has {openApprovalsCount} open approval
            {openApprovalsCount === 1 ? '' : 's'}. Mark Ready for Production anyway?
          </p>
        ) : (
          <p>
            This will move the Job to <strong>Ready for Production</strong>.
          </p>
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Continue</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
